import clsx from 'clsx';
import CalcInfoBlock from 'components/CalcInfoBlock/CalcInfoBlock';
import React, { useEffect, useState } from 'react';
import styles from './StartNew.module.scss';
import { Button, Modal } from 'tt-ui-lib/core';
import {
  CALCS_PER_PAGE,
  CALC_DESCRIPTIONS,
  CALC_NAMES,
  CALC_PAGE_TYPES,
  CALC_TYPES,
} from 'utils/calculatorUtils';
import CalcIcon from '../../../components/CalcIcon/CalcIcon';
import CompanySelectionModal from 'views/ScoreAndReporting/components/CompanySelectionModal/CompanySelectionModal';
import SustainabilityStartModal from 'views/ScoreAndReporting/components/SustainabilityStartModal/SustainabilityStartModal';
import { useSelectedContext } from 'context/contextSelector';
import ResultSelectionModal from 'views/ScoreAndReporting/components/ResultSelectionModal/ResultSelectionModal';
import { URL_CALCS_NEW } from 'constants/calculatorsPage';
import { useNavigate } from 'react-router';

const isProduction = process.env.REACT_APP_ENV === 'production';
const calcInDevelopnentList = {
  [CALC_TYPES.SUST_CSRD_ESRD]: true,
  [CALC_TYPES.SUST_GRI]: true,
  [CALC_TYPES.SUST_ISSB]: true,
  [CALC_TYPES.SUST_CDP]: true,
  [CALC_TYPES.CUSTOM_FILES]: isProduction,
  [CALC_TYPES.CUSTOM_REPORT]: isProduction,
  [CALC_TYPES.GLOBAL]: isProduction,
};

const StartNew = (props) => {
  const { targetWidth, setLoginOpen } = props;
  const navigate = useNavigate();
  const { user, selectedCompany: widjetCompany } = useSelectedContext((context) => context.user);
  const [isCompanyModalOpen, setIsCompanyModalOpen] = useState(false);
  const [isRoleModalOpen, setIsRoleModalOpen] = useState(false);
  const [isSustainabilityModalOpen, setIsSustainabilityModalOpen] = useState(false);
  const [isResultSelectionModalOpen, setIsResultSelectionModalOpen] = useState(false);

  const [startParams, setStartParams] = useState(null);

  const endpointReport = process.env.REACT_APP_REPORT || '';

  const redirectReport = (url) => {
    window.location.href = `${endpointReport}${url}`;
  };

  useEffect(() => {
    if (!startParams || !startParams?.name) return;
    if (startParams?.name && !startParams?.companyId) {
      if (widjetCompany && widjetCompany.selectedCompany) {
        const { selectedCompany } = widjetCompany;
        setStartParams((current) => ({ ...current, companyId: selectedCompany.id }));
      } else {
        setIsCompanyModalOpen(true);
      }
      return;
    }
    if (startParams?.companyId && !startParams?.entryType) {
      setIsSustainabilityModalOpen(true);
      return;
    }
    if (startParams?.entryType && !startParams?.selectedResultId) {
      setIsResultSelectionModalOpen(true);
      return;
    }

    if (
      startParams?.name &&
      startParams?.companyId &&
      startParams?.entryType &&
      startParams?.selectedResultId
    ) {
      redirectReport(
        `/startReport?type=${startParams.name}
        &companyId=${startParams.companyId}
        &entryType=${startParams.entryType}
        &resultId=${startParams.selectedResultId}`
      );
    }
  }, [startParams]);

  const onModalClose = (isCancel) => {
    if (isCancel) {
      setStartParams(null);
    }
    setIsResultSelectionModalOpen(false);
    setIsSustainabilityModalOpen(false);
    setIsCompanyModalOpen(false);
  };

  const onStartClick = (calc) => {
    // if user is individual they cannot use the calculator
    if (!user?.id) {
      setLoginOpen(true);
      return;
    }
    if (user?.role_name === 'individual') {
      setIsRoleModalOpen(true);
      return;
    }
    // if user select sustainability reporting show modal with options
    setStartParams({ name: calc });
  };

  return (
    <>
      <Modal
        open={isRoleModalOpen}
        onClose={() => setIsRoleModalOpen(false)}
        onClick={(e) => e.stopPropagation()}
        title="Upgrade your&nbsp;role"
        className={styles.modal}
      >
        <div className={styles.text}>
          We&apos;re sorry. This functionality is not available for your role.
        </div>
        <div className={clsx(styles.buttonBlock, styles.roleBB)}>
          <Button type="default" onClick={() => setIsRoleModalOpen(false)}>
            Cancel
          </Button>
          <Button type="primary" onClick={() => {}}>
            Upgrade your role
          </Button>
        </div>
      </Modal>
      <CompanySelectionModal
        open={isCompanyModalOpen}
        onClose={onModalClose}
        onFinish={(value) => setStartParams((current) => ({ ...current, companyId: value }))}
      />
      <SustainabilityStartModal
        open={isSustainabilityModalOpen}
        onClose={onModalClose}
        onFinish={(value) => setStartParams((current) => ({ ...current, entryType: value }))}
      />
      <ResultSelectionModal
        open={isResultSelectionModalOpen}
        companyId={startParams?.companyId}
        onClose={onModalClose}
        onFinish={(value) => setStartParams((current) => ({ ...current, selectedResultId: value }))}
        onStartNew={() => navigate(URL_CALCS_NEW)}
      />
      <div className={styles.container}>
        <>
          {CALCS_PER_PAGE[CALC_PAGE_TYPES.SUSTAINABILITY].map((calc) => (
            <CalcInfoBlock
              icon={<CalcIcon type={calc} />}
              headerText={CALC_NAMES[calc]}
              description={CALC_DESCRIPTIONS[calc]}
              onButtonClick={() => onStartClick(calc)}
              isDisabled={calcInDevelopnentList[calc]}
              targetWidth={targetWidth}
            />
          ))}
        </>
      </div>
    </>
  );
};

export default StartNew;
